.wrapper {
    display: grid;
    font-size: 1.375rem;
    grid-template-columns: 1fr 7fr;
    margin: 1rem 0;

    & dt {
        font-weight: 700;
    }
}

.heading {
    font-size: 1.4rem;
    font-weight: 700;
    margin-top: 1.5rem;
    text-transform: uppercase;

    &::before {
        background-color: var(--color-black);
        content: "";
        display: inline-block;
        height: 18px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 18px 18px;
        min-width: 18px;
    }
}
